import { RESET_SEARCH_OBJ, SET_SEARCH_OBJ } from "../action";
import { searchObj } from "./initial-store";

const initialState = searchObj;

const searchObjReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_OBJ:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_SEARCH_OBJ:
      return {
        ...initialState,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default searchObjReducer;
